import { render, staticRenderFns } from "./Inserir.vue?vue&type=template&id=5681af70&"
import script from "./Inserir.vue?vue&type=script&lang=js&"
export * from "./Inserir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports